import { BlogTag } from 'entities/tag'
import { Vertical } from 'entities/vertical'

export type BlogLeona = {
    id: string
    title: string
    feature: string
    author: string
    creation_date: string
    reading_time: number
    upvote_count: number
    tags: BlogTag[]
}

export type AuthorInfo = {
    id: string
    name: string
    imageUrl: string
    summary: string
}

export type Blog = {
    id: string
    title: string
    feature?: string
    author: string
    creationDate: string
    updated?: string
    readingTime: number
    upvoteCount: number
    tags: BlogTag[]
    originalSource?: string
    primaryVertical: Vertical
    authorInfo?: AuthorInfo
    published: boolean
    body: string
    creatorId: string
}

export type SeriesBlog = Pick<
    BlogLeona,
    | 'id'
    | 'title'
    | 'feature'
    | 'author'
    | 'creation_date'
    | 'reading_time'
    | 'upvote_count'
    | 'tags'
>

export const blogAuthorName = (
    blog: Pick<Blog, 'author'> & { authorInfo?: Pick<AuthorInfo, 'name'> },
) => {
    return blog.authorInfo?.name || blog.author
}
